import React from 'react';
import { FinancialConditionSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionSection.tsx';
import {
  STATE_AID_APPROVED_ROWS,
  STATE_AID_REQUESTED_ROWS,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/constants.ts';
import { StateAidMatrix } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidMatrix.tsx';

interface IStateAidApplicationsSectionProps {
  disabled: boolean;
  includesCovidSection: boolean;
}

export const StateAidApplicationsSection: React.FC<IStateAidApplicationsSectionProps> = ({
  disabled,
  includesCovidSection,
}) => (
  <>
    <FinancialConditionSection title="2. Затверджена, але не отримана державна допомога">
      <StateAidMatrix
        title="Відомості за затвердженими заявками"
        prefix="appr"
        rows={STATE_AID_APPROVED_ROWS}
        disabled={disabled}
      />
    </FinancialConditionSection>
    <FinancialConditionSection title="3. Заявки на державну допомогу без прийнятого рішення">
      <StateAidMatrix
        title="Відомості за поданими заявками"
        prefix="req"
        rows={STATE_AID_REQUESTED_ROWS}
        disabled={disabled}
      />
    </FinancialConditionSection>
    {includesCovidSection && (
      <FinancialConditionSection title="4. Державна допомога для подолання наслідків COVID-19">
        <StateAidMatrix
          title="Відомості про допомогу"
          prefix="covid"
          rows={STATE_AID_REQUESTED_ROWS}
          disabled={disabled}
        />
      </FinancialConditionSection>
    )}
  </>
);
